import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from "../../services/users.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-assigned-details-resume',
  templateUrl: './assigned-details-resume.component.html',
  styleUrls: ['./assigned-details-resume.component.scss']
})
export class AssignedDetailsResumeComponent implements OnInit {

  showDetails: boolean = false;
  panelOpenState = false;
  activeTab = 0;
  user_id:any;
  course_id:any;assessment_id:any; request_status:number=1;
  
 showDetailsEvent() { this.showDetails = !this.showDetails;  }
  closeResult = '';userLoginData:any=[];courseId:any='';assignDetailResume:any=[];assignDetailResumePro:any=[];
  constructor(private router: Router,private authUser: UsersService,private route: ActivatedRoute,private spinner: NgxSpinnerService,
    private modalService: NgbModal) { 
    if (localStorage.getItem('userLoginData') =='' || localStorage.getItem('userLoginData') == null) {
      this.router.navigateByUrl('/');
    }
  }
  ngOnInit(): void {
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.courseId = queryParams['courseId'];
    });
    this.checkCoursesStatus(this.userLoginData.user_id,this.courseId);
    if((this.userLoginData !='' || this.userLoginData != null) && (this.courseId !='' || this.courseId !=null)){
      this.assignCourseDetail(this.userLoginData.user_id);
    }
  }
  open(content: any, data:any) { 
    this.user_id = this.userLoginData.user_id
    this.course_id=data.course_id
    this.assessment_id= data.assessment_id,
    this.contactAdministrator(this.user_id,this.course_id,this.assessment_id, this.request_status)
    this.modalService.open(content, { centered: true, size: 'sm' }); 
  }
  open1(content: any) { 
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false  }); 
  }
  openMod(content: any, data:any) { 
    this.user_id = this.userLoginData.user_id
    this.course_id=data.course_id
    this.assessment_id= data.module_assessment_id,
    this.contactAdministrator(this.user_id,this.course_id,this.assessment_id, this.request_status)
    this.modalService.open(content, { centered: true, size: 'sm' }); 

  }
  /*******get course detail with progress */
  assignCourseDetail(userId:any){
    this.spinner.show();
    this.authUser.assignCourseDetails(userId,this.courseId).subscribe(
      data=>{
        if(data.status == 401){
           document.getElementById('successMsg')?.click();
           this.spinner.hide();
         }else{
          this.assignDetailResume = data.data;
          if(this.assignDetailResume.course_is_active == 0 || this.cousreEndDate(this.assignDetailResume.course_end_date) > 0){
            this.router.navigate(['/assigned']);
          }
          this.assignDetailResumePro = data.data.user_course_progress;
          this.spinner.hide();
         }
       
      },error=>{
        this.spinner.hide();
        //console.log(error);
      }
    )
  }
  /*****second convert into hr min and sec */
  secondsToHms(d:any) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    // var hDisplay = h > 0 ? h + (h == 1 ? " hr, " : " hr, ") : "";
    // var mDisplay = m > 0 ? m + (m == 1 ? " min, " : " min, ") : "";
    // var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " sec") : "";
    //return hDisplay + mDisplay + sDisplay; 
    return h+ ' hr ' +m+ ' min'; 
}
  /****go read submodule */
  goViewer(modId:any,subModlId:any,courseId:any){
    if(this.assignDetailResume.course_is_active == 0 || this.cousreEndDate(this.assignDetailResume.course_end_date) > 0){
      this.router.navigate(['/assigned']);
    }
    this.spinner.show();
    this.authUser.subModuleStartView(this.userLoginData.user_id,courseId,modId,subModlId).subscribe(
      data=>{
        if(data.status == 401){
          document.getElementById('successMsg')?.click();
          this.spinner.hide();
        }else{
          this.router.navigate(['/viewer'], { queryParams: {modId:modId,subModlId:subModlId,courseId:courseId} });
          this.spinner.hide();
        }
       
      },error=>{
        this.spinner.hide();
      }
    )
  }
  /****go read submodule */
  goViewerPass(modId:any,subModlId:any,courseId:any,view:any){
    if(this.assignDetailResume.course_is_active == 0 || this.cousreEndDate(this.assignDetailResume.course_end_date) > 0){
      this.router.navigate(['/assigned']);
    }
    this.router.navigate(['/viewer'], { queryParams: {modId:modId,subModlId:subModlId,courseId:courseId,view:view} });
  }
  contactAdministrator(user_id:number,course_id:any,assessment_id:any, request_status:any){
    if(this.assignDetailResume.course_is_active == 0 || this.cousreEndDate(this.assignDetailResume.course_end_date) > 0){
      this.router.navigate(['/assigned']);
    }
    this.spinner.show();
    this.authUser.contactAdministrator(user_id,course_id,assessment_id, request_status).subscribe(
      data=>{
        if(data.status == 401){
          document.getElementById('successMsg')?.click();
          this.spinner.hide();
        }
        this.spinner.hide();
      },error=>{
        this.spinner.hide();
      }
    )
  }
  cousreEndDate(endDate:any){
    var date2 = new Date();
    var date1 = new Date(endDate);
    var Time = date2.getTime() - date1.getTime(); 
    var Days = Time / (1000 * 3600 * 24);
    return Days;
  }
  navigationEvent() {
    localStorage.removeItem('userLoginData');
    this.router.navigateByUrl('/'); 
    
    }
    /****incase admin make course deactive than check and redirect to assign list */
    checkCoursesStatus(user_id:number,course_id:any){
      this.spinner.show();
      this.authUser.checkCourseStatus(user_id,course_id).subscribe(
        data=>{
         // console.log(data);
        if(data.exits == 0){
          this.router.navigateByUrl('/assigned'); 
        }
        this.spinner.hide();
        },error=>{
          this.spinner.hide();
        }
      )
    }

}
